import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import { useBillingUIContext } from "./BillingUIContext";
import BillingTable from "./billing-table/BillingTable";
import { BillingFilter } from "./billing-filter/BillingFilter";
import { RoleChecker } from "../../../RoleChecker";
import InvoiceTypeModal from "./invoice-type-modal/InvoiceTypeModal";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { fetchBilling } from "../_redux/billingAction";
import { BillingInvoice } from "./billing-invoice/BillingInvoice";
import { initialFilterInvoiceList, PAYMENT_STATUS } from "./BillingUIHelpers";
import * as actions from "../_redux/billingAction";
import LoadingAnimation from "./loading-animation/LoadingAnimation";
import HistoryPayment from "./history-payment/HistoryPayment";

export const BillingCard = () => {
  // Getting curret state of billing list from store (Redux)
  const { currentState } = useSelector(
    (state) => ({
      currentState: state.billing,
    }),
    shallowEqual
  );

  // console.log('====================================');
  // console.log(currentState);
  // console.log('====================================');
  const [planPayment, setPlanPayment] = useState({});
  const [queryParams, setQueryParams] = useState(initialFilterInvoiceList);

  const {
    invoiceItem,
    listLoading,
    billingInvoice,
    actionsLoading,
    invoiceList,
    totalCountInvoiceList,
  } = currentState;

  console.log('====================================');
  console.log(invoiceItem);
  console.log('====================================');
  const dispatch = useDispatch();
  useEffect(() => {
    //Requset API
    dispatch(actions.fetchBilling());
    dispatch(actions.getInvoiceList(queryParams));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryParams, dispatch]);

  useEffect(() => {
    if (billingInvoice) {
      if (billingInvoice.plan_payment)
        setPlanPayment(
          billingInvoice.plan_payment.find((item) => {
            if (item.status === "PAID") {
              return item;
            } else if (item.status === "WAITING") {
              return item;
            } else if (item.status === "FAILED") {
              return item;
            }
          })
        );
    }

  }, [currentState]);

  const [showModal, setShowModal] = useState({
    invoiceType: false,
  });

  const createPayment = (values) => {
    const { code, type, uuid, name } = values;
    const data = {
      plan_invoice_uuid: billingInvoice.uuid,
      payment_method_uuid: uuid,
      payment_method_type: type,
      payment_method_code: code,
      payment_method_name: name,
      payment_amount: billingInvoice.invoice_grand_total,
    };
    dispatch(actions.createPayment(data)).then((res) => {
      dispatch(fetchBilling());
      setShowModal((prevState) => ({
        ...prevState,
        invoiceType: false,
      }));
    });
  };

  return (
    <>

      <>
        {
          invoiceItem && invoiceItem.length > 0 ?
            <>
              <LoadingAnimation open={listLoading || actionsLoading} />
              <InvoiceTypeModal
                show={showModal.invoiceType}
                onHide={() =>
                  setShowModal((prevState) => ({
                    ...prevState,
                    invoiceType: false,
                  }))
                }
                createPayment={createPayment}
              />
              <Card>
                <CardHeader title="Invoice">
                  <CardHeaderToolbar>
                    {!planPayment && (
                      <button
                        className="btn btn-primary"
                        onClick={() =>
                          setShowModal((prevState) => ({
                            ...prevState,
                            invoiceType: true,
                          }))
                        }
                      >
                        Pilih Pembayaran
                      </button>
                    )}
                    {planPayment && planPayment.status === "EXPIRED" && (
                      <button
                        className="btn btn-primary"
                        onClick={() =>
                          setShowModal((prevState) => ({
                            ...prevState,
                            invoiceType: true,
                          }))
                        }
                      >
                        Pilih Pembayaran
                      </button>
                    )}
                  </CardHeaderToolbar>
                </CardHeader>
                <CardBody>
                  <BillingInvoice planPayment={planPayment} />
                </CardBody>
              </Card>
              <Card>
                <CardHeader title="Tagihan Berjalan" />
                <CardBody>
                  <BillingTable
                    invoiceItem={invoiceItem}
                    billingInvoice={billingInvoice}
                    listLoading={listLoading}
                  />
                </CardBody>
              </Card>
              <Card>
                <CardHeader title="Riwayat Pembayaran" />
                <CardBody>
                  <HistoryPayment
                    queryParams={queryParams}
                    setQueryParams={setQueryParams}
                    historyData={invoiceList}
                    listLoading={listLoading}
                    totalCount={totalCountInvoiceList}
                  />
                </CardBody>
              </Card>
            </>
            :
            <>
              <Card>
                <CardHeader title="Invoice">

                </CardHeader>
                <CardBody>
                  <p>Tidak Ada Tagihan Yang Perlu Dibayar</p>
                </CardBody>
              </Card>
            </>
        }
      </>

    </>
  );
};
